module.exports = __webpack_public_path__ + "static/img/jb_pic5.ff1644c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jb_pic5.jpg
// module id = 4Kkm
// module chunks = 5